<script setup lang="ts">
  import { computed } from 'vue'
  import { randomId } from '@/functions'

  const props = defineProps<{
    submitting: boolean,
    disabled?: boolean,
    id?: string,
  }>()

  const emit = defineEmits<{
    (e: 'submit'): void,
    (e: 'cancel'): void,
  }>()

  const defaultFormId = randomId()
  const formId = computed(() => props.id ?? defaultFormId)
</script>

<template>
  <form
    :id="formId"
    @submit.prevent="emit('submit')">
    <slot></slot>

    <slot name="action">
      <div class="flex-center xl:justify-start space-x-4 xl:pl-64">
        <app-submit
          class="btn-primary w-24"
          :disabled="disabled"
          :loading="submitting">
          Simpan
        </app-submit>
        <app-button
          class="btn-low-priority w-24"
          :disabled="submitting"
          @click="emit('cancel')">
          Batal
        </app-button>
      </div>
    </slot>
  </form>
</template>

<style lang="postcss" scoped>
  :deep() {
    section {
      @apply my-4 py-4;
    }
    section + section {
      @apply border-t;
    }
  }
</style>
